import template from './box.html';

export const boxComponent = {
  name: 'box',
  restrict: 'E',
  template,
  transclude: {
    header: '?boxHeader',
    table: '?boxTable'
  },
  controllerAs: 'vm',
  bindings: {
    title: '@',
    noContent: '<'
  }
};
